module.exports = __webpack_public_path__ + "media/landing-page/bg-hero-3-min-8eb67ae6.svg";